import script from "./SpringRuleList.vue?vue&type=script&lang=ts&setup=true&name=StockList"
export * from "./SpringRuleList.vue?vue&type=script&lang=ts&setup=true&name=StockList"

const __exports__ = script;

export default __exports__